import { styled } from '@mui/material/styles'
import { Box, Card, Grid, Typography } from '@mui/material'

interface MiscTextProps {
  color?: any
  fontSize?: string
  fontWeight?: number | string
}

interface TextButtonProps {}

export const TextButton = styled(Typography)((props: TextButtonProps) => ({
  fontSize: '13px',
  padding: 2,
  fontFamily: 'NotoSans',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'var(--color-surface-subtle)'
  }
}))

export const MiscText = styled(Typography)(
  ({
    theme,
    color,
    fontSize,
    fontWeight
  }: MiscTextProps & { theme?: any }) => ({
    fontSize: fontSize ?? '14px',
    color: color ?? theme?.palette.text.disabled,
    fontWeight: fontWeight ?? 200,
    fontFamily: 'NotoSans'
  })
)

interface BlockContainerProps {
  loading: number
}

export const BlockContainer = styled(Grid)(
  ({ loading }: BlockContainerProps) => ({
    height: 'wrap-content',
    flexDirection: 'column',
    justifyContent: 'center',

    pointerEvents: loading === 1 ? 'none' : 'all'
  })
)

export const PhoneTypePicker = styled(Box)<{
  selected?: boolean
}>(({ theme, selected }) => ({
  borderTopLeftRadius: '25px',
  borderBottomLeftRadius: '25px',
  minWidth: '40px',
  width: '40px',
  height: '100%',
  cursor: 'pointer',
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  borderLeft: `1px solid ${theme.palette.border.primary}`,
  borderBottom: `1px solid ${theme.palette.border.primary}`,
  borderTop: `1px solid ${theme.palette.border.primary}`,
  background: selected
    ? theme.palette.card.primary
    : 'var(--color-surface-subtle)',
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',

  padding: theme.spacing(0, 2),

  '&:hover': {
    backgroundColor: theme.palette.card.primary
  }
}))

export const PhoneTypeContainer = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  cursor: 'pointer',
  gap: 16,
  marginTop: 8,
  padding: theme.spacing(0, 4),
  alignItems: 'flex-start',
  flexShrink: 0,
  '&:hover': {
    backgroundColor: 'var(--color-surface-subtle)'
  }
}))

export const PhoneTypeText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  letterSpacing: '0.00938em',
  fontFeatureSettings: "'clig' off, 'liga' off",
  fontFamily: 'NotoSans',
  fontSize: '1rem',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '1.15625rem' /* 115.625% */
}))

export const PhoneTypeMisc = styled(PhoneTypeText)(() => ({
  fontSize: '0.85rem',
  fontWeight: 300,
  lineHeight: '1.0625rem' /* 106.25% */
}))
